export default __webpack_public_path__ + "static/media/flisekompaniet-cover.66291718.png";